module.exports = __webpack_public_path__ + "static/img/背景板(3).52efb685.png";